import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=4b5efaa2&scoped=true&"
import script from "./AppHeader.vue?vue&type=script&lang=js&"
export * from "./AppHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=4b5efaa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5efaa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5efaa2')) {
      api.createRecord('4b5efaa2', component.options)
    } else {
      api.reload('4b5efaa2', component.options)
    }
    module.hot.accept("./AppHeader.vue?vue&type=template&id=4b5efaa2&scoped=true&", function () {
      api.rerender('4b5efaa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/AppHeader.vue"
export default component.exports